module.exports = __webpack_public_path__ + "static/img/12-6.3475fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/12-6.png
// module id = BUO8
// module chunks = 15